import type { PairVerdict } from "@/types/api";

/**
 * Ported from products/x2mail-admin/src/components/VerdictChip.tsx.
 * BELOW_VOLUME is deliberately NOT green — it means "not enough data to
 * know", not "OK" (design doc §6.4 — this distinction is the whole point of
 * the dashboard).
 */
export interface VerdictChipProps {
  verdict: PairVerdict;
  onClick?: () => void;
}

const VERDICT_CONFIG: Record<PairVerdict, { label: string; className: string; icon: string }> = {
  OK: {
    label: "OK",
    icon: "🟢",
    className: "border-green-800 bg-green-950 text-green-400 hover:border-green-600",
  },
  ALERT_LOW: {
    label: "ALERT",
    icon: "🔴",
    className: "border-red-700 bg-red-950 text-red-400 hover:border-red-500 animate-pulse",
  },
  ALERT_HIGH: {
    label: "ALERT↑",
    icon: "🔴",
    className: "border-red-700 bg-red-950 text-red-400 hover:border-red-500 animate-pulse",
  },
  BELOW_VOLUME: {
    // NEUTRAL — deliberately NOT green (§6.4: sedno dashboardu)
    label: "ZA MAŁO DANYCH",
    icon: "⚪",
    className: "border-zinc-700 bg-zinc-900 text-zinc-400 hover:border-zinc-500",
  },
  NO_BASELINE: {
    label: "BRAK BASELINE",
    icon: "◻️",
    className: "border-dashed border-zinc-700 bg-zinc-900 text-zinc-500 hover:border-zinc-500",
  },
};

export function VerdictChip({ verdict, onClick }: VerdictChipProps) {
  const cfg = VERDICT_CONFIG[verdict];
  const Tag = onClick ? "button" : "span";

  return (
    <Tag
      onClick={onClick}
      className={[
        "inline-flex items-center gap-1 rounded border px-2 py-0.5 text-xs font-medium transition-colors",
        cfg.className,
        onClick ? "cursor-pointer" : "cursor-default",
      ].join(" ")}
    >
      <span aria-hidden="true">{cfg.icon}</span>
      {cfg.label}
    </Tag>
  );
}
